<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_4_' + this.id]">
    <div class="background">
      <div class="vlan">
        <img src="https://cdn.exploreve.fr/content/IM4/vlan.svg" alt="VLAN" />
      </div>
      <div class="daria-et-erwin">
        <div class="erwin">
          <img src="https://cdn.exploreve.fr/content/IM4/erwin_triste.svg" alt="Erwin" />
        </div>
      </div>
      <div class="bulle bulle1">
        <div class="cadre">
          <p>
            Mais... Où suis-je ? C'est un peu glauque cet endroit... Et, oh !! La porte est verrouillée, impossible de
            l'ouvrir et de m'échapper.... Ohlala, qu'est ce que je vais faire ? Allez Erwin, courage ! Je suis sûr qu'en
            fouillant un peu cette cabane, je vais trouver la solution pour sortir !
          </p>
        </div>
      </div>
      <div class="bouton">
        <a
          href="https://view.genial.ly/5fc21ad8c852dd0d3637fb27"
          class="btn btn-secondary btn-lg"
          @click="immersion_finished"
          >Explorer la cabane ></a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IM_4_3",
  data: function () {
    return {
      id: 3
    };
  },
  methods: {
    immersion_finished: () => {
      localStorage.setItem("immersion04_finished", "yes");
    }
  }
};
</script>

<style scoped lang="scss">
.background {
  width: 100vw;
  height: calc(100vh - 60px);
  position: relative;
  top: 0;
  right: 0;
  background-image: url(https://cdn.exploreve.fr/content/IM4/cabane.jpeg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.daria-et-erwin {
  position: absolute;
  top: 12vh;
  left: 15vw;
}
.erwin {
  position: absolute;
  top: 25vh;
  left: 25%;
  img {
    height: 50vh;
  }
}
.cadre {
  position: absolute;
  background-color: white;
  width: 30vw;
  border-radius: 15px;
  text-align: left;
  padding: 10px;
  z-index: 10;
  p {
    margin-bottom: 0 !important;
    font-family: Faune;
    font-style: normal;
    font-weight: normal;
    font-size: 3vh;
    line-height: 4vh;
  }
}
.bulle1 {
  position: absolute;
  top: 33vh;
  left: 27vw;
  & .cadre::after {
    content: "";
    position: absolute;
    right: 100%;
    top: 22%;
    width: 0;
    height: 0;
    transform: rotate(80deg);
    border-left: 2.5vh solid transparent;
    border-right: 2.5vh solid transparent;
    border-top: 7vh solid white;
  }
}

.bouton {
  position: absolute;
  bottom: 5vh;
  right: 15vw;
  z-index: 9999;
  a {
    padding: 8px 24px;
    text-decoration: none !important;
    color: white !important;
    font-family: Faune;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
  }
}

.vlan {
  position: absolute;
  top: 50vh;
  left: 6vw;
  z-index: 99;
  & img {
    width: 12vw;
  }
}
</style>
